import messages from '../../../locales/messages';
import { Link, ClickableTile } from 'carbon-components-react';
import PublicImage from 'src/common/components/PublicImage';
import './finalStep.scss';
import { ArrowRight32 } from '@carbon/icons-react';
import { img_result } from '../../../constants/default';
import C4DVideoPlayerContainer from '@carbon/ibmdotcom-web-components/es/components-react/video-player/video-player-container';
import * as VideosIDs from '../../../constants/default';
import { createUseTranslation } from 'src/common/hooks/widgets/useTranslation';
import { useQradarEDRSelector } from '../../../lib/redux/hooks';
import { segmentsTracking } from 'src/common/lib/tracker';

type FinalStepProps = {
  experienceProducts: () => void;
  contactSales: () => void;
  setLearnMore: React.Dispatch<React.SetStateAction<boolean>>;
  setInteractiveDemo: React.Dispatch<React.SetStateAction<boolean>>;
  optionSelected: number;
  pathSelected: string;
};
export const FinalStep = ({
  experienceProducts,
  contactSales,
  setLearnMore,
  setInteractiveDemo,
  optionSelected,
  pathSelected,
}: FinalStepProps) => {
  const backgroundColor = () => {
    switch (optionSelected) {
      case 1:
        return 'final_employeeExperience';
      case 2:
        return 'final_expertAssistant';
      case 3:
        return 'intelligenceDocProcessing';
      case 4:
        return 'final_enterpriseSearch';
    }
  };
  const AEMMessages = useQradarEDRSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);

  return (
    <>
      <div className="bx--col-lg-7 bx--col-md-8 bx--col-sm-4">
        <div className="bx--row">
          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
            <ClickableTile
              className={`contactSaleTile ${backgroundColor()}`}
              role="button"
              onClick={() => {
                contactSales();
              }}
            >
              <div className="bx--row">
                <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                  <PublicImage
                    imgPath={img_result}
                    widgetId="ai-solutions-advisor"
                    id="img01"
                    alt="AI Solutions Advisor icon picture"
                    className="se_imgs"
                  />
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                  <p className="textHeading">
                    {useTranslation('final_col1_paragraph_01')}
                  </p>
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-lg-11 bx--col-md-6 bx--col-sm-3">
                  <p className="textSubHeading">
                    {useTranslation('final_col1_paragraph_02')}
                  </p>
                </div>
                <div className="bx--col-lg-5 bx--col-md-2 bx--col-sm-1 colIMG">
                  <Link
                    role="button"
                    className="bx-link-class arrowIMG"
                    id="se-next-step-id"
                    rel="noreferrer"
                    renderIcon={() => <ArrowRight32 className="Image" />}
                    onClick={() => {
                      contactSales();
                    }}
                  />
                </div>
              </div>
            </ClickableTile>
          </div>
        </div>
        <div className="bx--row">
          <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-2">
            <ClickableTile
              className="subTile"
              role="button"
              onClick={() => {
                setInteractiveDemo(true);
                segmentsTracking('CTA Clicked', {
                  pageTitle: 'AI Solutions Advisor',
                  object: 'AI Solutions Advisor page',
                  resultValue: 'CTA clicked',
                  CTA: 'Experience the products',
                  location: `${pathSelected} Assessment`,
                  action: '',
                  field: '',
                });
              }}
            >
              <div className="bx--row">
                <div className="bx--col-lg-16 bx--col-md-8 bx--col-sd-4">
                  <p className="textSubTile">
                    {useTranslation('final_col1_paragraph_03')}
                  </p>
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-lg-16 bx--col-md-8 bx--col-sd-4">
                  <Link
                    role="button"
                    className="bx-link-class arrowIMG"
                    id="se-next-step-id"
                    rel="noreferrer"
                    renderIcon={() => <ArrowRight32 className="Image" />}
                    onClick={() => {
                      console.log('clicking');
                      setInteractiveDemo(true);
                      segmentsTracking('CTA Clicked', {
                        pageTitle: 'AI Solutions Advisor',
                        object: 'AI Solutions Advisor page',
                        resultValue: 'CTA clicked',
                        CTA: 'Experience the products',
                        location: `${pathSelected} Assessment`,
                        action: '',
                        field: '',
                      });
                    }}
                  />
                </div>
              </div>
            </ClickableTile>
          </div>
          <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-2">
            <ClickableTile
              className="subTile"
              role="button"
              onClick={() => {
                setLearnMore(true);
                segmentsTracking('CTA Clicked', {
                  pageTitle: 'AI Solutions Advisor',
                  object: 'AI Solutions Advisor page',
                  resultValue: 'CTA clicked',
                  CTA: 'Learn More',
                  location: `${pathSelected} Assessment`,
                  action: '',
                  field: '',
                });
              }}
            >
              <div className="bx--row">
                <div className="bx--col-lg-16 bx--col-md-8 bx--col-sd-4 learnMoreTile">
                  <p className="textSubTile">
                    {useTranslation('final_col1_paragraph_04')}
                  </p>
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-lg-16 bx--col-md-8 bx--col-sd-4">
                  <Link
                    role="button"
                    className="bx-link-class arrowIMG"
                    id="se-next-step-id"
                    rel="noreferrer"
                    renderIcon={() => <ArrowRight32 className="Image" />}
                    onClick={() => {
                      console.log('Learn More');
                      setLearnMore(true);
                      segmentsTracking('CTA Clicked', {
                        pageTitle: 'AI Solutions Advisor',
                        object: 'AI Solutions Advisor page',
                        resultValue: 'CTA clicked',
                        CTA: 'Learn More',
                        location: `${pathSelected} Assessment`,
                        action: '',
                        field: '',
                      });
                    }}
                  />
                </div>
              </div>
            </ClickableTile>
          </div>
        </div>
      </div>
      <div className="bx--col-lg-9 bx--col-md-8 bx--col-sm-4 columns">
        <C4DVideoPlayerContainer
          aspectRatio="16x9"
          videoId={VideosIDs.videoId_background}
          playing-mode="inline"
          background-mode={true}
        />
      </div>
    </>
  );
};
